/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionsReportFilter
 */
export interface OutputUavMissionsReportFilter {
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionsReportFilter
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputUavMissionsReportFilter
     */
    values: Array<string>;
}

/**
 * Check if a given object implements the OutputUavMissionsReportFilter interface.
 */
export function instanceOfOutputUavMissionsReportFilter(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('values' in value)) return false;
    return true;
}

export function OutputUavMissionsReportFilterFromJSON(json: any): OutputUavMissionsReportFilter {
    return OutputUavMissionsReportFilterFromJSONTyped(json, false);
}

export function OutputUavMissionsReportFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionsReportFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'values': json['values'],
    };
}

export function OutputUavMissionsReportFilterToJSON(value?: OutputUavMissionsReportFilter | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'values': value['values'],
    };
}

